module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_3.f2e069e0.png";